module.exports = __webpack_public_path__ + "static/media/Gorebyss_gaussian2.b3d867f7.png";